/**
 * Created by gaoying on 2017/10/31.
 */
import Vue from 'vue'

import VueCookies from '@/plugins/vueCookies.js'

import VueResource from 'vue-resource'

import store from '../store'

import router from '../router'

import util from './util'
import { buildRequestIdHeader } from './request-id'

import QRCodeAlg from 'arale-qrcode'

import { lockrSet, lockrGet, lockrRm, lockrFlush } from '@/tools/lockr'

const transferArrayBufferToJSON = (arrayBufferData) => {
  var uint8_msg = new Uint8Array(arrayBufferData)
	// 解码成字符串
  var decodedString = String.fromCharCode.apply(null, uint8_msg)
  console.log(decodedString)
  var data = null
	// parse,转成json数据
  try {
    data = JSON.parse(decodedString)
  } catch (error) {
    data = decodedString
  }
  return data
}

export function redirectRightPageAfterLogin (router, willToPath, error) {
  const current_route = router.currentRoute

  const whiteList = ['/login', '/refresh', '/chooseorg', '/auth-redirect', '/403']

	// console.log(current_route, 'current_route')

  const fullPath = current_route.fullPath

  if (fullPath) {
    if (whiteList.some((each_url) => fullPath.includes(each_url))) {
			// location.href=`#/${willToPath}`;
      if (willToPath !== '403') {
        router.replace({
          path: `/${willToPath}`
        })
      } else {
        router.replace({
          path: `/${willToPath}`,
          query: {
            message: error
          }
        })
      }
    } else {
			// location.href=`#/${willToPath}?redirect=${fullPath}`;

      if (willToPath == 'login') {
				// 存在不同权限的老师共用一台电脑，上个老师的权限页，对于下一个老师无用
				// 又或者同一个老师在之前登录能查看某个权限页，但是权限被收回，也没有查看的资格，没有保留在redirect的必要
        router.replace({
          path: `/${willToPath}`
					// query: {
					// 	redirect: fullPath
					// }
        })
      } else {
        if (willToPath !== '403') {
          router.replace({
            path: `/${willToPath}`,
            query: {
              redirect: fullPath
            }
          })
        } else {
          router.replace({
            path: `/${willToPath}`,
            query: {
              redirect: fullPath,
              message: error
            }
          })
        }
      }
    }
  } else {
		// location.href=`#/${willToPath}`;

    router.replace({
      path: `/${willToPath}`
    })
  }
}

// export const API = 'https://i.manbanapp.com'; //测试环境 废弃
// export const API = 'https://deva.manbanapp.cn'; //测试环境
// export const API = 'https://a.manbanapp.cn'; //线上环境
export const API = process.env.NODE_ENV === 'production' ? 'https://a.manbanapp.cn' : 'https://deva.manbanapp.cn'

const pc_version = '2.12.2' // pc 版本号 为了观察用户不更新的占比

Vue.use(VueResource)
Vue.http.interceptors.push((request, next) => {
  request.headers = buildRequestIdHeader(request.headers || {})
  const token = VueCookies.get('token')
  const uuid = localStorage.getItem('uuid')
		// console.log(VueCookies, 'VueCookies')
		// console.log(token, 'VueCookies token')

		// console.log(VueCookies.keys(), '$cookies.keys()')

  var oDate = new Date()

		// return oDate.getTimezoneOffset()
  const nTimezone = Math.floor(-oDate.getTimezoneOffset() / 60) + ''
  const tzHeader = 'x-timezone'
		// console.log(Vue.http.headers.common);

  Vue.http.headers.common[tzHeader] = nTimezone // 加上时区

  const tzstrHeader = 'x-timezone-str'

  Vue.http.headers.common[tzstrHeader] = util.findTimeZoneName()

		// const versionHeader = "'x-version";
    //
		// Vue.http.headers.common[versionHeader] = pc_version

  const platform = 'x-platform'

  Vue.http.headers.common[platform] = 'pc' // 后台区分pc、小程序（在微信内置浏览器UA相同）代码，返回不同数据

  if (uuid) {
    const uuidHeader = 'x-utdid'
    Vue.http.headers.common[uuidHeader] = uuid
  }
  if (process.env.BUILD_TIME) {
    Vue.http.headers.common['x-version'] = process.env.BUILD_TIME
  }
		// console.dir(request, 'request');
   	if (token) {
   		Vue.http.headers.common.authorization = `Basic ` + btoa(token + ':')
   	} else {
		  delete Vue.http.headers.common.authorization
   }

		// const lock_errors =
  	next((response) => {
			// console.log(response, 'response all');
			// console.dir(response, 'response');
    if (response.status === 0) {  // request failed
				// console.log(lock_errors, 'lock_errors')
      if (store.getters.lock_errors.includes('req_fail')) {
        return false
      } else {
        store.dispatch('other/addLockErrorMsg', 'req_fail')
        window.myapp.$message({
          type: 'error',
          message: '网络环境不好，请检查网络设置',
          customClass: 'manban-toast__error',
          onClose: () => {
            store.dispatch('other/delLockErrorMsg', 'req_fail')
          }
        })
      }
    } else if (response.status === 401) {
      lockrFlush()
      if (store.getters.lock_errors.includes('req_login_fail')) {
        return false
      } else {
        store.dispatch('other/addLockErrorMsg', 'req_login_fail')
        window.myapp.$message({
          type: 'error',
          message: '登录失效，请重新登录',
          customClass: 'manban-toast__error',
          onClose: () => {
            store.dispatch('other/delLockErrorMsg', 'req_login_fail')
          }
        })
      }

				// const current_route = router.currentRoute

				// console.log(current_route, 'current_route')

				// const fullPath = current_route.fullPath

				// if (fullPath) {

				// } else {
        // // location.href="#/login";

				// }
      redirectRightPageAfterLogin(router, 'login')
    } else if (response.status == 403) { // 在机构中无权限
				// location.href="#/chooseorg";
				// if (response.body.reason === 'NO_VIEW_PERMISSION') {
				// 	redirectRightPageAfterLogin(router, '403', response.body.error)
				// }

      if (store.getters.lock_errors.includes('access_login_fail')) {
        return false
      } else {
        store.dispatch('other/addLockErrorMsg', 'access_login_fail')
        setTimeout(() => {
          store.dispatch('other/delLockErrorMsg', 'access_login_fail')
        }, 3000)
					// window.myapp.$message({
					// 	type: 'error',
					// 	message: '登录失效，请重新登录',
					// 	customClass: 'manban-toast__error',
					// 	onClose: () => {
					// 		store.dispatch('other/delLockErrorMsg', 'req_login_fail');
					// 	}
					// });
      }

				// 对403的特殊处理
      if (response.body.constructor === ArrayBuffer) {
        response.body = transferArrayBufferToJSON(response.body)
      }
      if (response.body.reason === 'NO_OPERATION_PERMISSION') {

      } else if (response.body.reason === 'NO_VIEW_PERMISSION') {
        redirectRightPageAfterLogin(router, '403', response.body.error)
      } else {
        redirectRightPageAfterLogin(router, 'chooseorg')
      }
    } else if (response.status === 404) { // 没有找到这个资源 not_found
      const data = response.data || {}

      const error = data.error || '没有找到这个资源'
      if (store.getters.lock_errors.includes('not_found')) {
        return false
      } else {
        store.dispatch('other/addLockErrorMsg', 'not_found')
        window.myapp.$message({
          type: 'error',
          message: error,
          customClass: 'manban-toast__error',
          onClose: () => {
            store.dispatch('other/delLockErrorMsg', 'not_found')
          }
        })
      }
    } else if (response.status === 418) {
      const data = response.data || {}

      const error = data.error || ''
      const kf_url = data.kf_url || ''

      const result = new QRCodeAlg({
        render: 'svg',  /*  生成的类型 'svg' or 'table dom元素类型 */
        text: kf_url, /* 二维码的链接 */
        size: 100                                          /* 二维码的大小 */
      })
      const svg = new XMLSerializer().serializeToString(result)

      if (store.getters.lock_errors.includes('pop_up_wechat_box')) {
        return false
      } else {
        window.myapp.$alert(`
						<div>
							<div class="lrpadding48px">
								<h4 class="fs20px fcblack edit_title">微信扫描右侧二维码</h4>
								<div class="flexDirectionColumn pb22px">
									<div class="textleft">
									${error}
									</div>
									<img style="width: 100px; height: 100px;" class="mt10px disblock" src='data:image/svg+xml;base64,${window.btoa(svg)}' />
								</div>
							</div>
						</div>
						`, '', {
  dangerouslyUseHTMLString: true,
  confirmButtonText: '知道了',
  confirmButtonClass: 'normal-button',
  customClass: 'manban-alert',
  callback: () => {
    store.dispatch('other/delLockErrorMsg', 'pop_up_wechat_box')
  }
})
			    }
    } else if (response.status === 417) {
      window.myapp.$alert('检测到新版本，是否更新？', '升级提示', {
        confirmButtonText: '确定',
        callback: action => {
          window.location.reload()
        }
      })
    }
			// console.log('all headers', response.headers);

			// response.headers.get('content-disposition');
    　　　return response
  })
})

const getUserSetApi = () => {
  const user_set_api = store.getters.user_set_api
  console.log(user_set_api)
  return user_set_api || API
}

export const SET_API = () => {
  const api = API.includes('deva.manbanapp') ? getUserSetApi() : API
  return api
}

export function getBaseUrl () {
  return API.includes('deva.manbanapp') ? getUserSetApi() : API
}

function getOptionsWithAuthorization (options = {}) {
  const authHeaders = util.getAuthorizationWithOrgId()
  if (!authHeaders.token) {
    delete authHeaders.Authorization
  }
  delete authHeaders.token

  const headers = Object.assign({}, authHeaders, options.headers || {})
  delete headers.token

  return Object.assign({}, options, { headers })
}

// Vue.prototype.__reqManageList = [];

// 不再有域名前缀，url必须是完整api链接
export function getFileBuffer (url, params, options = {}) {
  let sub = []
	// options.before = function(request) {
	// 	Vue.prototype.__reqManageList.push(request);
	// }
  for (let key in params) {
  	if (params.hasOwnProperty(key)) {
  		sub.push(key + '=' + params[key])
  	}
  }
	// const current_use_api = API.includes('i.manbanapp') ? getUserSetApi() : API

  if (sub.length > 0) {
    return Vue.http.get(url + '?' + sub.join('&'), options)
  } else {
  	return Vue.http.get(url, options)
  }
}

// 仍有默认域名前缀
export function get (url, params, options = {}) {
  options = getOptionsWithAuthorization(options)
  let sub = []
	// options.before = function(request) {
	// 	Vue.prototype.__reqManageList.push(request);
	// }
  for (let key in params) {
  	if (params.hasOwnProperty(key)) {
  		sub.push(key + '=' + params[key])
  	}
  }
  const current_use_api = API.includes('deva.manbanapp') ? getUserSetApi() : API

  if (sub.length > 0) {
    return Vue.http.get(current_use_api + url + '?' + sub.join('&'), options)
  } else {
  	return Vue.http.get(current_use_api + url, options)
 	}
}
export function post (url, param, options = {}) {
  options = getOptionsWithAuthorization(options)
	// options.before = function(request) {
	// 	Vue.prototype.__reqManageList.push(request);
	// }
  const current_use_api = API.includes('deva.manbanapp') ? getUserSetApi() : API

  return Vue.http.post(current_use_api + url, param, Object.assign({emulateJSON: true}, options))
}
export function postJson (url, param, options = {}) {
  options = getOptionsWithAuthorization(options)
	// options.before = function(request) {
	// 	Vue.prototype.__reqManageList.push(request);
	// }
  const current_use_api = API.includes('deva.manbanapp') ? getUserSetApi() : API

  return Vue.http.post(current_use_api + url, param, options)
}
